import React from 'react';
import type {DataGridServerProps} from '@igp/shared/components/data-grid';
import {DataGridServer} from '@igp/shared/components/data-grid';

import {useDataGridNegativeCarryoverReportColumns} from '../hooks';
import type {NegativeCarryoverReportViewModel, NegativeCarryoverReportViewModelKeys} from '../types';

type DataGridNegativeCarryoverReportProps = Omit<
    DataGridServerProps<NegativeCarryoverReportViewModel, NegativeCarryoverReportViewModelKeys>,
    'columns'
> & {
    columns: NegativeCarryoverReportViewModelKeys[];
};

export function DataGridNegativeCarryoverReport(props: DataGridNegativeCarryoverReportProps) {
    const columns = useDataGridNegativeCarryoverReportColumns(props.columns);

    return <DataGridServer {...props} columns={columns} />;
}
